import { clone } from '@jkhy/frontend-utils/functions';

export const saveRequestBody = (
    institutionOptions,
    companyAccounts,
    companyFeatures,
    hasIssuedItemsModification
) => {
    const Options = [];
    const ProductFeatureAccounts = [];
    if (institutionOptions.allowShowAchExceptions()) {
        const achEnabled = companyFeatures.getACHExceptionFeatures();
        const achKeys = Object.keys(achEnabled);
        achKeys.forEach(key => {
            Options.push({ name: key, value: achEnabled[key] });
        });
        ProductFeatureAccounts.push(companyAccounts.getAchExceptionBody());
    }

    if (institutionOptions.allowWorkCheckExceptions()) {
        const checkEnabled = companyFeatures.getCheckExceptionFeatures();
        const checkKeys = Object.keys(checkEnabled);
        checkKeys.forEach(key => {
            Options.push({ name: key, value: checkEnabled[key] });
        });
        ProductFeatureAccounts.push(companyAccounts.getCheckExceptionBody());
    }

    if (institutionOptions.allowManageAchFilter()) {
        const filtersEnabled = companyFeatures.getACHFiltersFeatures();
        const filtersKeys = Object.keys(filtersEnabled);
        filtersKeys.forEach(key => {
            Options.push({ name: key, value: filtersEnabled[key] });
        });
        const featureParticipations = clone(companyAccounts.getAchFiltersBody());
        featureParticipations.featureName = companyAccounts.keyMapping.achFilterManagement;
        ProductFeatureAccounts.push(featureParticipations);
    }

    if (hasIssuedItemsModification) {
        const issuedItemsModificationEnabled = companyFeatures.getIssuedItemsModificationFeatures();
        const issuedItemsModificationKeys = Object.keys(issuedItemsModificationEnabled);
        issuedItemsModificationKeys.forEach(key => {
            Options.push({ name: key, value: issuedItemsModificationEnabled[key] });
        });
    }

    return { ProductFeatureAccounts, Options };
};
